import React, { FC } from 'react';
import { Field } from 'react-final-form';
import { RadioCardWrapper } from 'components/forms';
import styles from './Form.module.scss';

export const formFields = [
  {
    label: 'form.field.plan.classic.label',
    description: 'form.field.plan.classic.description',
    name: 'plan',
    value: 'CLASSIC',
  },
  {
    label: 'form.field.plan.premium.label',
    description: 'form.field.plan.premium.description',
    name: 'plan',
    value: 'PREMIUM',
  },
  {
    label: 'form.field.plan.enterprise.label',
    description: 'form.field.plan.enterprise.description',
    name: 'plan',
    value: 'ENTERPRISE',
  },
];

const AppPlan: FC = () => (
  <div className={styles.fieldsContainer}>
    {formFields.map((field: any) => (
      <Field
        type='radio'
        component={RadioCardWrapper}
        // isSubmitOnChange={false}
        key={field.value}
        {...field}
      />
    ))}
  </div>
);

export default AppPlan;
